/**
 * 申請受付　画面名記録用ファイル
 */
// tslint:disable-next-line:no-namespace
export namespace UketsukeScreenName {
  /** 申請受付　トップメニュー */
  export const UKETSUKE_MENU: string = 'uketsukeMenu';
  /** 申請書登録 */
  export const APPLICATION_FORM: string = 'applicationForm';
  /** 個別情報登録  自治体選択 */
  export const MUNICIPALITY_SELECT: string = 'municipalitySelect';
  /** 個別情報登録　工事 */
  export const PARTIAL_INFO_CONSTRUCTION: string = 'partialInfoConstruction';
  /** 個別情報登録　委託 */
  export const PARTIAL_INFO_CONSULTING: string = 'partialInfoConsulting';
  /** 個別情報登録　物品　中分類小分類 */
  export const PARTIAL_INFO_GOODS: string = 'partialInfoGoods';
  /** 個別情報登録 物品　資格情報 */
  export const PARTIAL_INFO_CREDENTIALS: string = 'partialInfoCredentials';
  /** 個別情報登録 物品　大分類 */
  export const PARTIAL_INFO_MAJOR_CATEGORY: string = 'partialInfoMajorCategory';
  /** 受付表発行 */
  export const RECEPTION_SLIP_ISSUE: string = 'receptionSlipIssue';
  /** 受注者ユーザ登録 */
  export const ACCEPTER_USER_REGIST: string = 'accepterUserRegistration';

  /** 申請受付発注者トップページ */
  export const UKETSUKE_ORDER_MAIN: string = 'uketsukeOrderMain';
  /** 申請業者データ検索 */
  export const SEARCH_APPLICATION_TRADER: string = 'applicationTraderSearch';
  /** 添付書類確認 */
  export const CHECK_ATTACHED_FILE: string = 'checkAttachedFile';
  /** 申請受理・不受理結果 */
  export const CHECK_RESULT: string = 'checkResult';
  /** パスワード発行業者検索 */
  export const PASSWORD_ISSUER_SEARCH: string = 'passwordIssuerSearch';
  /** パスワード発行結果 */
  export const PASSWORD_ISSUE_RESULT: string = 'passwordIssueResult';
  /** データ一検索・一覧 */
  export const APP_TRADER_SEARCH: string = 'applicationTraderSearch';
  //2024/01/05 [2023L-14] add start
  /** 申請履歴検索 */
  export const SEARCH_PRO_HISTRIES: string = 'processHistoriesSearch';
  //2024/01/05 [2023L-14] add end
}
